import React from "react";
import styled from "styled-components";

import binoculars from "../assets/binoculars.jpg";

export default function AboutUs() {
  return (
    <Section id="aboutus">
      <div className="title">
        <h2>About Us</h2>
      </div>

      <div className="aboutus">
        <div className="aboutUsText">
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <h1 className="aboutHeadTrailer">FLEETLINE TOURS AND TRAVEL</h1>
          <br />
          <br />
          We aim at ensuring that our best offered services are being realised
          by our clients inline with thier expectations basing on individual
          interests, time scale, budget and other requirements
          <br />
          <br />
          <br />
          <h1 className="aboutHeadTrailer">VISIT • EXPLORE • EXPERIENCE</h1>
        </div>
        <div className="imgWrapper">
          <img className="aboutUsImage" src={binoculars} alt="about_knife" />
        </div>
      </div>
    </Section>
  );
}

const Section = styled.section`
  margin: 5rem 0;
  height: fit-content;
  .title {
    text-align: center;
    padding-bottom: 1rem;
    color: #276d9b;
  }
  .aboutus {
    display: flex;
    justify-content: space-between;
    margin: 0 2rem;
    //gap: 2rem;
    background-color: #d1e7f6;
    border-radius: 15px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    transition: 0.3s ease-in-out;
    //min-height: 50vh;
    height: fit-content;
    width: auto;
    .aboutUsText {
      flex: 1;
      padding: 20px 20px;
      font-size: 17px;
      .aboutHeadTrailer {
        font-size: 16px;
        text-align: center;
      }
    }
    .imgWrapper {
      flex: 1;
      .aboutUsImage {
        height: 100%;
        width: 100%;
        object-fit: cover;
        border-radius: 15px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .aboutus {
      flex-direction: column;
      margin: 0;
      .aboutUsText {
        justify-content: center;
      }
      .aboutUsImage {
        width: 100%;
        height: 100%;
        border-radius: 15px;
      }
    }
  }
`;
